<div class="sa-reset body flex">
  <div class="sa-reset-container flex col-12 h-100">
    <div class="sa-reset-details flex-6 flex-col flex">
      <!-- <sa-icon icon="saras_logo" size="44"></sa-icon> -->
       <sa-icon img="{{product_logo}}" imgWidth="110" imgHeight="38"></sa-icon>
      <div class="sa-reset-details-content flex-center flex-col left">
        <div class="">
          <div class="sa-reset-details-title title text-32">Welcome Back!</div>
          <div class="text title">
            Login to access your data solutions and insights
          </div>
        </div>
      </div>
    </div>

    <div class="sa-reset-form flex-6 flex flex-center">
      @if(showInitialLoader){

      }@else{
        @if(!messageView){
          <div class="sa-form-container">
            @if(isLoading){
            <div class="sa-form-overlay"></div>
            }
            @if(toast){
            <sa-toast
              class="block"
              [subHeading]="toast.subHeading || ''"
              [status]="toast.status || 'success'"
            ></sa-toast>
            }
    
            <!--    - chip(small)       -->
    
            <div class="sa-form-header">
              <div class="title">Reset your password</div>
              <div class="sub-title">
                Set your new password for @if(email){<b>{{
                  email
                }}</b
                >}
              </div>
            </div>
    
            <div class="sa-form-wrapper">
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <formly-form
                  [form]="form"
                  [model]="model"
                  [fields]="fields"
                  (modelChange)="modelChangeHandler($event)"
                >
                </formly-form>
    
                <!-- [disabled]="!form.valid" -->
                <sa-button
                  [isSubmit]="true"
                  text="Update New Password"
                  type="primary"
                  size="medium"
                  [state]="form.valid ? 'default' : 'disabled'"
                  width="100%"
                  [showSpinner]="isLoading"
                ></sa-button>
              </form>
            </div>
    
            <div class="text text-14">
              Don’t have an account?
              <a href="signup" class="link">Create account</a>
            </div>
          </div>
          }@else{
          <sa-message-view
            [props]="messageView"
            (onClick)="onMessageViewEvent($event)"
          ></sa-message-view>
          }
      }
      
    </div>
  </div>
</div>
